import { render } from "./TaxonomyButtons.vue?vue&type=template&id=07dda8f4&ts=true"
import script from "./TaxonomyButtons.vue?vue&type=script&lang=ts"
export * from "./TaxonomyButtons.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__